/**
 * MdFileInput — hidden file input that accepts .md files.
 *
 * Used by SkillFormDialog (F-SKILL-1 B1) to import markdown content
 * into the content editor. Wraps the raw <input> so the roros/no-raw-html
 * ESLint rule stays satisfied.
 */

import React from 'react';

export interface MdFileInputProps {
  /** Ref forwarded to the hidden <input> element for programmatic .click(). */
  inputRef: React.RefObject<HTMLInputElement | null>;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  'data-testid'?: string;
}

export function MdFileInput({ inputRef, onChange, 'data-testid': testId }: MdFileInputProps) {
  return (
    <input
      ref={inputRef}
      type="file"
      accept=".md"
      className="sr-only"
      aria-hidden="true"
      tabIndex={-1}
      onChange={onChange}
      data-testid={testId}
    />
  );
}
